import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";


const initialState = {
    jackpotHistoryList: [],
    totalJackpotHistory: 0,
    singleJackpotHistory: null,
    loading: false,
};

const slice = createSlice({
    name: "jackpot",
    initialState: { ...initialState },
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(Act.jackpotHistoryListApi.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(Act.jackpotHistoryListApi.fulfilled, (state, action) => {
            state.jackpotHistoryList = action.payload.data;
            state.totalJackpotHistory = action.payload.totalcount;
            state.loading = false;
        });
        builder.addCase(Act.jackpotHistoryListApi.rejected, (state, action) => {
            state.loading = false;
        });
        builder.addCase(Act.jackpotHistoryDetailsApi.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(Act.jackpotHistoryDetailsApi.fulfilled, (state, action) => {
            state.singleJackpotHistory = action.payload.data;
            state.loading = false;
        });
        builder.addCase(Act.jackpotHistoryDetailsApi.rejected, (state, action) => {
            state.loading = false;
        });
    },
});

export default slice;